//Importación de librerias
//---------------SISETA---------------
//Comunes



//Creamos y asignamos los datos necesarios de forseti
const siseta = [
  
]


//Exportamos los datos de siseta
export default siseta;



//////////////////
// WEBPACK FOOTER
// ./static/js/sistemas/siseta.js
// module id = null
// module chunks = 